/* app/js/src/components/calendar/expandable/calendar-expandable/calendar-expandable.component.scss */
.cursor-pointer {
  cursor: pointer;
}
.expanded-show {
  height: auto;
  background-color: #ebf0f4;
  line-height: normal;
  padding-bottom: 29px;
  border-bottom: 1px solid #dfe2e6;
}
.items-content {
  display: flex;
  flex-direction: column;
  margin-left: 131px;
  margin-right: 5px;
}
.item {
  display: flex;
  position: relative;
  background-color: #e2e8f1;
  width: 100%;
  height: 35px;
  margin-top: 5px;
  align-items: center;
  font-family: "Open Sans", sans-serif;
}
.audio {
  font-weight: 400;
}
.title-container {
  display: flex;
  flex-direction: row;
  flex-basis: 119px;
  align-items: center;
}
.event-icon {
  display: flex;
  align-items: center;
  margin-left: 8px;
}
.item-title-text {
  font-size: 12px;
  margin-left: 8px;
}
.list-container {
  display: flex;
  flex-direction: row;
}
.audio-tracks {
  font-size: 11px;
}
.track-container {
  width: 37px;
  flex-basis: 200px;
  cursor: pointer;
  margin-right: 32px;
  -webkit-user-select: none;
  user-select: none;
  text-transform: uppercase;
}
.track {
  display: flex;
  align-items: center;
}
.ear-icon {
  display: flex;
  align-items: center;
}
.audio-track-text-active {
  margin-left: 6.37px;
}
.audio-track-text-inactive {
  margin-left: 6.37px;
  color: rgba(125, 143, 161, 0.5);
  fill: black;
}
.add-audio-icon {
  position: absolute;
  display: flex;
  align-items: center;
  right: 32px;
  cursor: pointer;
}
.add-audio-icon ::ng-deep svg path {
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
  transform-origin: center center;
  -webkit-transform-origin: center center;
  -ms-transform-origin: center center;
}
.rotate-add-audio-icon ::ng-deep svg path {
  -ms-transform: rotate(-45deg);
  -webkit-transform: rotate(-45deg);
  transform: rotate(-45deg);
}
.add-audio-popup {
  position: absolute;
  background: white;
  right: 50px;
  z-index: 2000;
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.2);
  border: solid 1px #e1e6eb;
  -webkit-user-select: none;
  user-select: none;
  width: 192px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 6px;
  padding-bottom: 6px;
}
.add-audio-popup-hidden {
  display: none;
}
.select-items {
  padding-left: 7px;
  padding-right: 7px;
  width: 100%;
}
.add-audio-file-text {
  font-size: 10px;
  font-weight: 700;
  margin-top: 6px;
  margin-bottom: 6px;
  margin-left: 13px;
}
.select-item-container {
  display: flex;
  align-items: center;
  height: 26px;
  cursor: pointer;
  color: #7b90a4;
}
.select-item-container:hover {
  background-color: #ebf0f4;
}
.audio-track-text {
  display: flex;
  align-items: center;
  font-weight: 400;
  font-size: 12px;
  margin-left: 13px;
}
.subtitles {
  font-weight: 400;
}
.subtitles-list {
  font-size: 11px;
}
.language-container {
  -webkit-user-select: none;
  user-select: none;
}
.eye-icon {
  display: flex;
  align-items: center;
}
.language {
  width: 37px;
  cursor: pointer;
  margin-right: 32px;
  display: flex;
  align-items: center;
  text-transform: uppercase;
}
.language-text-active {
  margin-left: 6.37px;
}
.language-text-inactive {
  margin-left: 6.37px;
  color: rgba(125, 143, 161, 0.5);
  fill: black;
}
.language-text {
  margin-left: 6.73px;
  margin-right: 24.54px;
}
.event-container {
  font-size: 11px;
}
.item-title-container {
  display: flex;
  flex-direction: row;
  flex-basis: 119px;
}
.item-name {
  display: flex;
  flex-basis: 165px;
  flex-grow: 1;
}
.item-text-overrides {
  display: flex;
  flex-basis: 165px;
  flex-grow: 1;
}
.start-time-container {
  display: flex;
  flex-basis: 93px;
}
.end-time-container {
  display: flex;
  flex-basis: 97px;
}
.duration-time-container {
  display: flex;
  flex-basis: 93px;
}
.offset-time-container {
  display: flex;
  flex-basis: 68px;
}
.time-display {
  position: relative;
  left: 5px;
}
.column-titles-container {
  display: flex;
  font-family: "Open Sans", sans-serif;
  font-size: 12px;
  height: 36px;
  margin-bottom: -5px;
  flex-direction: row;
  align-items: center;
}
.empty-space {
  display: flex;
  flex-basis: 119px;
}
.name-text {
  overflow: hidden;
  flex: 1 1 0%;
  text-overflow: ellipsis;
}
.text-overrides-text {
  flex: 1 1 25%;
  overflow: hidden;
  text-overflow: ellipsis;
}
.start-text {
  flex-basis: 90px;
  display: flex;
}
.end-text {
  flex-basis: 90px;
  display: flex;
}
.duration-text {
  flex-basis: 90px;
  display: flex;
}
.offset-text {
  flex-basis: 90px;
  display: flex;
}
.actions {
  display: flex;
  flex-basis: 100px;
}
.right-items {
  display: flex;
  flex-direction: row;
  margin-left: auto;
  margin-right: 34.4px;
  align-items: center;
}
.rule-item {
  margin-right: 16px;
  font-size: 12px;
  text-decoration-line: underline;
  color: #40c4ff;
}
.instance-item {
  margin-right: 21px;
  font-size: 12px;
  text-decoration-line: underline;
  color: #40c4ff;
}
.generated-events-container {
  position: relative;
}
.new-sec-event-component {
  margin-right: 21px;
}
/*# sourceMappingURL=calendar-expandable.component.css.map */
